export const useIsScratchcardEnabled = () =>
  useIsFeatureFlagEnabled(FEATURE_FLAGS.scratchcards)
